/**
 * Utility functions for admin access control
 */

import { useTransactionCertificateStore } from '../../store/transaction-certificates.store';

/**
 * Check if user is an admin based on the isAdmin flag from store
 * This flag is set by calling the check-admin API after login
 * @returns boolean - true if user is admin
 */
export const isAdmin = (): boolean => {
  const { isAdmin } = useTransactionCertificateStore.getState();
  return isAdmin;
};

/**
 * Get the admin status from store
 * @returns boolean - true if CB-ID is in admin list
 */
export const getAdminStatus = (): boolean => {
  return useTransactionCertificateStore.getState().isAdmin;
};

/**
 * Check if the admin user is in view-only mode for the currently selected CB.
 * Returns true only when the user is an admin AND is viewing a CB other than their own.
 * When an admin views their own CB (cbLicensingCode === originalAdminCBID), they get edit access.
 * @returns boolean - true if admin is viewing another CB's data (view-only), false if edit is allowed
 */
export const isViewOnlyAdminMode = (): boolean => {
  const state = useTransactionCertificateStore.getState();
  if (!state.isAdmin) return false; // Non-admin users are never in view-only admin mode
  // Admin is view-only when the currently selected CB differs from their own CB
  return state.cbLicensingCode !== state.originalAdminCBID;
};
